import { c as _c } from "react/compiler-runtime";
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import ApplePayDeleteDomainModal from 'modules/profile/payment-gateways/integrations/stripe/components/apple-pay-delete-domain-modal';
import { ApplePayDomain } from 'modules/profile/payment-gateways/integrations/stripe/hooks';
import ButtonLikeLink from 'shared/components/button-like-link';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface ApplePayDomainListProps {
  domains: ApplePayDomain[];
  afterLeave: () => void;
}
const ApplePayDomainList = t0 => {
  const $ = _c(4);
  const {
    domains,
    afterLeave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== afterLeave || $[1] !== domains || $[2] !== t) {
    t1 = <Disclosure>{t2 => {
        const {
          open
        } = t2;
        return <><DisclosureButton as={ButtonLikeLink}>{open ? t("dashboard.settings.apple_pay.hide_connected_domains") : t("dashboard.settings.apple_pay.show_connected_domains")}</DisclosureButton><DisclosurePanel>{domains.map(t3 => {
              const {
                id,
                host_name
              } = t3;
              return <ApplePayDeleteDomainModal key={id} hostName={host_name} domainId={id} afterLeave={afterLeave} />;
            })}</DisclosurePanel></>;
      }}</Disclosure>;
    $[0] = afterLeave;
    $[1] = domains;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default ApplePayDomainList;